<div class="widget-container">

	<div class="filter-container m-4" *ngIf="!toPrint">

		<!-- PERIODS FILTERS-->
		<div class="row" *ngIf="!userParentFilters">
			<div class="col-sm-6 col-md-3 col-lg-3">
				<label for="periodSelect">{{"rt_history.periods" | translate}}</label>
				<ng-select
					class="select"
					[items]="periods"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'period', value: $event.value})"
					[placeholder]="'g.durations' | translate"
					[(ngModel)]="selectedPeriod"
				></ng-select>
			</div>

			<!-- voltage filter -->
			<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="!performance">
				<label for="batteryVoltageSelect">{{"fleet_reports.battery_voltage" | translate}}</label>
				<ng-select
					id="batteryVoltageSelect"
					class="select"
					[items]="batteryVoltagesOptions"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'voltageFilter', value: $event.value})"
					[placeholder]="'qv.voltage' | translate"
					[(ngModel)]="selectedBatteryVoltage"
				></ng-select>
			</div>

			<!-- capacity filter -->
			<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="!performance">
				<label for="batteryCapacitySelect">{{"devices.battery_capacity" | translate}}</label>
				<ng-select
					id="batteryCapacitySelect"
					class="select"
					[items]="batteryCapacitiesOptions"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'capacityFilter', value: $event.value})"
					[placeholder]="'qv.capacity' | translate"
					[(ngModel)]="selectedBatteryCapacity"
				></ng-select>
			</div>
		</div>
	</div>

	<div [ngClass]="toPrint ? 'scores-wrapper-print' : 'scores-wrapper'" *ngIf="!showNoData || !noData; else noDataTemplate">
		<div [ngClass]="toPrint ? 'score-card-print' : 'score-card'" *ngFor="let score of scoreConfigs">
			<div>
				<strong>
					<p>{{ score.titleKey | translate }}
						<app-help-tooltip *ngIf="showTooltip" [field]="score.tooltipKey"></app-help-tooltip>
					</p>
				</strong>
			</div>

			<svg width="140" height="140">
				<circle cx="60" cy="60" r="50" class="bg"></circle>
				<circle cx="60" cy="60" r="50" class="progress" [style.stroke]="score.color"
					[style.stroke-dasharray]="circumference"
					[style.stroke-dashoffset]="score.dashOffset">
				</circle>
				<text x="45%" y="55%" text-anchor="middle" dy=".5em"> {{ score.value }}%</text>
			</svg>

			<div class="status">
				<span class="status-badge" [style.backgroundColor]="score.color">
					{{ score.status }}
				</span>
			</div>
		</div>
	</div>
</div>
<ng-template #noDataTemplate class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>